import { PlatformLocation } from '@angular/common';
import { inject } from '@angular/core';

import { TellentRoute } from '@core/tellent-types';

export const injectTellentHostUrlBuilder = () => {
  const platformLocation = inject(PlatformLocation);
  const base = platformLocation.getBaseHrefFromDOM();

  return (route: TellentRoute, params?: Record<string, string | number | string[]>) => {
    const path = route.buildPath(params);

    if (path.startsWith('?')) {
      const pageUrlSearchParams = new URLSearchParams(path);
      const currentUrl = new URL(document.location.href);

      for (const [k, v] of pageUrlSearchParams.entries()) {
        currentUrl.searchParams.append(k, v);
      }

      const { origin, href } = currentUrl;

      return href.replace(origin, '').replace(base, '');
    }

    return path;
  };
};
